import { render } from "./Community.vue?vue&type=template&id=13f1a93e&scoped=true&ts=true"
import script from "./Community.vue?vue&type=script&lang=ts"
export * from "./Community.vue?vue&type=script&lang=ts"

import "./Community.vue?vue&type=style&index=0&id=13f1a93e&lang=scss&scoped=true"

import exportComponent from "C:\\bonch\\okimi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f1a93e"]])

export default __exports__